import { formatFileSize } from '@/lib/utils/formatters';
import LoaderCircleSpin from './LoaderCircle';

interface FileDetailProps {
  name: string;
  size: number;
  isLoading: boolean;
  onRemove: () => void;
}

export default function FileDetail({
  name,
  size,
  isLoading,
  onRemove,
}: FileDetailProps) {
  return (
    <div className="flex max-h-[34px] justify-between border-b border-[#CBD2D9]">
      <div className="flex">
        {isLoading && <LoaderCircleSpin/>}
        <div>
          <p className="font-normal text-sm leading-[16px]">{name}</p>
          <p className="font-normal text-[12px]">{formatFileSize(size)}</p>
        </div>
      </div>
      <div className="flex items-center">
        <p className="text-[14px] leading-sm mr-3">{isLoading ? '' : '100%'}</p>
        <button className="w-[24px] h-[24px] text-gray-400" onClick={onRemove}>X</button>
      </div>
    </div>
  )
}
